type Result<T, E = Error> = { success: true; value: T } | { success: false; error: E }

const ok = <T>(value: T): Result<T> => ({
	success: true,
	value,
})

const err = <E = Error>(error: E): Result<never, E> => ({
	success: false,
	error,
})

export { err, ok }
export type { Result }
